import { theme } from '@factorialco/deprecated-design-system'
import { TrainingSessionCalendarEventFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { CalendarEventNormalizer } from 'modules/core/components/CalendarEventList/types'
import { dateBackendDateTimeToUITime, dateToString, stringToDate } from 'modules/core/lib/dates'

export const trainingSessionCalendarEventNormalizer: CalendarEventNormalizer<
  TrainingSessionCalendarEventFragment
> = (item) => {
  const startOn = item.startsAt ? stringToDate(item.startsAt, 'backend_datetime') : undefined
  const endOn = item.endsAt ? stringToDate(item.endsAt, 'backend_datetime') : undefined

  const buildTimeRange = (start: string, end: string) => {
    return `${dateToString(moment(start), 'ui_time')} - ${dateToString(moment(end), 'ui_time')}`
  }

  let description = ''
  if (startOn && endOn) {
    if (startOn.isSame(endOn, 'day')) {
      description = buildTimeRange(item.startsAt, item.endsAt)
    } else {
      description = `${startOn.format('D MMM, YYYY')} — ${endOn.format('D MMM, YYYY')}`
    }
  } else if (startOn) {
    description = dateBackendDateTimeToUITime(item.startsAt)
  }

  const title = item.training?.name ?? item.name
  const subtitle = !item.training?.name ? undefined : item.name

  return {
    title,
    subtitle,
    color: theme.colors.viridian1200,
    description,
    ...(endOn && startOn && !endOn.isSame(startOn, 'day')
      ? {
          fromDate: startOn.toDate(),
          toDate: endOn.toDate(),
        }
      : {
          toDate: startOn ? startOn.toDate() : undefined,
        }),
    isPending: false,
  }
}
